function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      "enableBackground": "new 0 0 27 27"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("g", {
    id: "Layer_1"
  }, React.createElement("circle", {
    className: "st0",
    style: {
      "fill": "#FFFFFF"
    },
    cx: 13.5,
    cy: 13.5,
    r: 12.5
  })), React.createElement("g", {
    id: "Layer_4"
  }, React.createElement("polyline", {
    className: "st1",
    style: {
      "fill": "#FFFFFF",
      "stroke": "#20A637",
      "strokeWidth": 4,
      "strokeLinecap": "round",
      "strokeLinejoin": "round",
      "strokeMiterlimit": 10
    },
    points: "7.4,13.8 12,17.8 19.6,9.2 \t"
  })));
};

export default __webpack_public_path__ + "static/media/confirmed-ready.e447c70f.svg";
export { SvgComponent as ReactComponent };